"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Utils = require("../Utils");
var _EyeDropperIcon = _interopRequireDefault(require("./Icons/EyeDropperIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var EyeDropper = function EyeDropper(_ref) {
  var onChange = _ref.onChange,
    filledCanvasRef = _ref.filledCanvasRef,
    context2 = _ref.context2,
    setRgba = _ref.setRgba,
    setHexCode = _ref.setHexCode,
    setIsModal = _ref.setIsModal,
    layout = _ref.layout,
    noColor = _ref.noColor,
    disableNoColor = _ref.disableNoColor;
  var pickColor = function pickColor() {
    if (layout === "popup") {
      // setIsModal(false);
    }
    var eyeDropper = new window.EyeDropper();
    eyeDropper.open().then(function (res) {
      if (noColor) {
        disableNoColor();
      }
      var sRGBHex = res.sRGBHex;
      var rgba = (0, _Utils.convertHexToRGBA)(sRGBHex, 100);
      onChange("rgba(".concat(rgba.r, ",").concat(rgba.g, ",").concat(rgba.b, ",").concat(rgba.alpha, ")"));
      var filledCanvasContext = (0, _Utils.getContext2D)(filledCanvasRef);
      (0, _Utils.generateColors)(filledCanvasContext, context2, rgba.rbgaString);
      var rgb = (0, _Utils.convertRgbString)(rgba.rbgaString);
      var hexcode = (0, _Utils.rgbToHex)(rgb[0], rgb[1], rgb[2]);
      (0, _Utils.setFilledSelectorPosition)(rgb[0], rgb[1], rgb[2], noColor);
      setRgba(_objectSpread(_objectSpread({}, rgba), {}, {
        r: rgb[0],
        g: rgb[1],
        b: rgb[2],
        alpha: 100
      }));
      setHexCode(hexcode.rgbString);
      if (layout === "popup") {
        setIsModal(true);
      }
    }).catch(function (e) {
      console.log(e);
      if (layout === "popup") {
        setIsModal(true);
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-eye-dropper"),
    onClick: pickColor
  }, /*#__PURE__*/_react.default.createElement(_EyeDropperIcon.default, null));
};
var _default = EyeDropper;
exports.default = _default;